t = require('app/scripts/views/internal/teacup-with-helpers')('card_detail_list')

module.exports = t.renderable ({ editable, listName, showBoardName, boardName, boardUrl }) ->
  t.p '.u-inline-block.u-bottom', ->
    className = t.classify('js-open-move-from-header': editable, disabled: !editable)
    if showBoardName
      t.format 'board-in-list', { boardClassName: '', boardName, boardUrl, listClassName: className, listName }
    else
      t.format 'in-list', { className, listName }
